import * as types from "./product.actiontype"
const initialState={
    loading:false,
    error:false,
    Productes:[]    
}
export const Productreducer=(state=initialState,{type,payload})=>{

    switch (type){


        default :{
            return state
        }
    }

}